import React, { useState } from "react";
import useLang from "../../hooks/useLang";
import classes from "./PriceConfigurations.module.css";
import DefaultInput from "../../components/form/DefaultInput";
import { Button, Input } from "antd";
import { toast } from "react-toastify";
import api from "../../utils/axios";

export default function ChangeGoogleMapsKey() {
	const { strings } = useLang("googleMapsApiKey");
	const [apiKey, setApiKey] = useState<string>("");

	const updateGoogleApiKey = async () => {
		if (apiKey === "") {
			toast.error("Api key nuk mund te jete i zbrazet");
			return;
		}
		try {
			const result = await api.post(
				`Configuration/updateGoogleApiKey?apiKey=${apiKey}`
			);
			if (result.status === 200) {
				toast.success("Api key u ndryshua me sukses");
				setApiKey("");
			} else {
				toast.error("Api key nuk mund te ndryshohet");
			}
		} catch (error) {
			toast.error("Api key nuk mund te ndryshohet");
		}
	};

	return (
		<div className={classes.mainContainer}>
			<h1 className={classes.title}>{strings?.titles.main}</h1>
			<h3 className="text-center">
				Vetem nese doni te ndryshoni api key duhet te shkruani ketu
			</h3>
			<Input
				// disabled={disabled}
				// className={styles.numberInput}
				placeholder={strings?.search}
				name="apiKey"
				id="apiKey"
				onChange={(e) => setApiKey(e.target.value)}
				value={apiKey}
			/>
			<div className="flex w-full">
				<Button
					className="button2"
					onClick={() => updateGoogleApiKey()}
				>
					Ruaj
				</Button>
			</div>
		</div>
	);
}
